import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IMAGE_URL } from "../../utils/constant";
import img2 from "../../assets/images/dummyImage.png";
import {
	setOffcanvas,
	setMiniSidebarMenuOn,
	setMiniHover,
} from "../../actions/settingsAction";
import SideBar from "./sideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/images/salek-logo.webp";
import notificationIcon from "../../assets/images/Bell-Notification--Streamline-Sharp.png";
import logoutIcon from "../../assets/images/Logout-2--Streamline-Sharp.png";
import userIcon from "../../assets/images/User-Story--Streamline-Sharp.png";
import { logout } from "../../actions/customer";

const Menu = (props) => {
	const [isOpen, setIsOpen] = useState(false);
	const [isModal, setModal] = useState(false);

	const toggleDropdown = () => setIsOpen(!isOpen);

	const logoutFun = () => {
		sessionStorage.clear();
		logout();
	};

	let profilePic = img2;
	let userData = JSON.parse(localStorage.getItem("user"));
	if (userData && userData.logo) {
		profilePic = `${IMAGE_URL}${userData.logo}`;
	}

	let orgName = "salek x";
	if (userData && userData.organisationId) {
		orgName = userData.organisationId.orgName;
	}

	let clientName = "";

	if (JSON.parse(localStorage.getItem("OrgName"))) {
		if (sessionStorage.getItem('vendorId')) {
			clientName = sessionStorage.getItem('vendorName')
		} else {
			clientName = JSON.parse(localStorage.getItem("OrgName"));
		}
	}

	return (
		<>
			<div
				id="left-sidebar"
				className={`sidebar${props.miniSideMenuOn ? " mini_sidebar_on" : ""
					}`}
			>
				<div className="navbar-brand d-flex flex-column">
					<Link to="/">
						<span className="d-flex justify-content-start align-items-center">
							<img
								src={logo}
								className="user-photo mr-2 sideBarLogo"
								alt="User Profile"
							/>
							{/* {"salek x"} */}
						</span>
						{/* <span className="clientName">{clientName}</span> */}
					</Link>
					<button
						type="button"
						className="btn-toggle-offcanvas btn btn-sm float-right"
						onClick={() => props.setOffcanvas(!props.offcanvas)}
					>
						<i className="lnr lnr-menu icon-close"></i>
					</button>
				</div>

				<div className="sidebar-scroll">
					<nav id="left-sidebar-nav" className="sidebar-nav">
						<SideBar props={props.auth || {}} />
					</nav>
				</div>

				<div className="footer-Data relative flex items-center space-x-3 p-3 rounded-lg cursor-pointer">
					<div className="relative">
						<img
							src={profilePic}
							alt="User"
							className="w-10 h-10 rounded-full profileimg"
						/>
						<span className="absolute top-0 right-0 w-3 h-3 bg-red-500 border-2 border-white rounded-full span_circle"></span>
					</div>

					<div className="flex flex-col" onClick={toggleDropdown}>
						<span className="text-sm font-semibold">
							{userData?.fullName}
						</span>
						<span
							className="text-xs emailLogout"
							style={{
								wordBreak: "break-word",
								overflowWrap: "break-word",
							}}
						>
							{userData?.email}
						</span>
					</div>

					<FontAwesomeIcon
						icon={faChevronDown}
						className={`text-gray-600 transition-transform ${isOpen ? "rotate-180" : ""
							}`}
						onClick={toggleDropdown}
					/>
					{isOpen && (
						<div className="absolute right-0 mt-2 w-40 bg-white shadow-md rounded-lg p-2 logout_menu">
							<Link
								to="/app-inbox"
								className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
							>
								<img
									src={notificationIcon}
									className="img-fluid"
								/>
								Notifications
							</Link>
							<Link
								to="/profile"
								className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
							>
								<img src={userIcon} className="img-fluid" />
								View Profile
							</Link>
							<Link
								to="#"
								className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 borderBottomNone"
								style={{ color: "#D44226", cursor: "pointer" }}
								onClick={() => setModal(true)}
							>
								<img src={logoutIcon} className="img-fluid" />
								Logout
							</Link>
						</div>
					)}
				</div>
			</div>

			{isModal && (
				<div
					className={`modal modalLogout fade ${isModal ? "d-block show" : ""
						}`}
					id="exampleModal"
					onClick={() => setModal(false)}
				>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Log out?</h5>
							</div>
							<div className="modal-body">
								<p className="mb-0">
									{window?.location?.href?.indexOf(
										"brandshield"
									) === -1
										? "Are you sure you want to Logout from salek x?"
										: "Are you sure you want to Logout from Brandshield?"}
								</p>
							</div>
							<div className="modal-footer">
								<button
									type="button"
									className="btn btn-round btn-primary"
									style={{
										color: "black",
										fontWeight: "bold",
									}}
									onClick={logoutFun}
								>
									Yes
								</button>
								<button
									type="button"
									className="btn btn-round btn-default"
									onClick={() => {
										setModal(false);
										setIsOpen(false);
									}}
								>
									No
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	offcanvas: state.settings.offcanvas,
	miniSidebar: state.settings.miniSidebar,
	miniSideMenuOn: state.settings.miniSideMenuOn,
	miniHover: state.settings.miniHover,
	auth: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
	setOffcanvas: (e) => dispatch(setOffcanvas(e)),
	setMiniSidebarMenuOn: (e) => dispatch(setMiniSidebarMenuOn(e)),
	setMiniHover: (e) => dispatch(setMiniHover(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
